import Immutable from 'immutable';
import {
  FLAG_BUS_ASSIGNMENT_SCHEDULES,
  GET_BUS_ASSIGNMENT_SCHEDULES,
  CLEAR_BUS_ASSIGNMENT_SCHEDULES,
  FLAG_BUS_ASSIGNMENT_SCHEDULE_ACTIVITY,
  GET_BUS_ASSIGNMENT_SCHEDULE,
  CLEAR_BUS_ASSIGNMENT_SCHEDULE,
} from '../../../actions/types';
import { COLLECTION_SHAPE } from '../../../config/shapes';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    loading: Immutable.List(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_BUS_ASSIGNMENT_SCHEDULES:
      return state.setIn(['all', 'loading'], payload);
    case GET_BUS_ASSIGNMENT_SCHEDULES:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_BUS_ASSIGNMENT_SCHEDULES:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_BUS_ASSIGNMENT_SCHEDULE_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_BUS_ASSIGNMENT_SCHEDULE:
      return state.setIn(['current', 'content'], Immutable.Map(payload));
    case CLEAR_BUS_ASSIGNMENT_SCHEDULE:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    default:
      return state;
  }
};
